<template>
  <div class="modify-contain"
       v-if="visable_spu_modify">
    <el-card shadow="never">
      <div slot="header"
           class="spu_modify_header">
        <el-page-header @back="close_spu_modify()">
          <div class="modify_spu_header_title"
               slot="content">
            产品编号：{{ spu_id }}
          </div>
        </el-page-header>
      </div>

      <!-- 商品标题 -->
      <div class="content-line"
           style="display: flex">
        <div class="content-title">
          <span class="required"
                style="color: red">*</span>
          产品名称：
        </div>
        <div class="content-input">
          <el-input size="mini"
                    v-model="spu_name"
                    placeholder="请输入产品标题"
                    maxlength="20"
                    show-word-limit></el-input>
        </div>
      </div>

      <!-- 商品编码 -->
      <div class="content-line"
           style="display: flex">
        <div class="content-title">
          <span class="required"
                style="color: red">*</span>
          产品编码：
        </div>
        <div class="content-input">
          <el-input size="mini"
                    v-model="out_spu_id"
                    placeholder="请输入产品编码"
                    maxlength="15"
                    show-word-limit></el-input>
        </div>
        <el-link style="margin-left: 10px"
                 @click="creatOutSpuId"
                 :underline="false"
                 type="primary"
                 icon="el-icon-refresh">生成编号</el-link>
      </div>
      <!-- 产品主图 -->
      <div class="content-img"
           style="display: flex">
        <div class="content-title">
          <span class="required"
                style="color: red">*</span>
          产品主图：
        </div>
        <div class="content-upload">
          <el-upload class="avatar-uploader"
                     :name="file_name"
                     :action="$ip + '/add_image?key_name=spu_image'"
                     :show-file-list="false"
                     :with-credentials="true"
                     :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload"
                     accept=".jpg, .jpeg, .png, .gif">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 class="avatar" />
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <!-- 所在目的地 -->
      <div class="content-line-dest"
           style="display: flex">
        <label class="content-dest">
          <span class="required"
                style="color: red">*</span>
          所在目的地：
        </label>

        <div>
          <el-cascader style="width: 300px"
                       size="mini"
                       :show-all-levels="false"
                       v-model="selectDests"
                       :options="option"
                       @change="handleChoice"
                       :props="defaultProp"
                       clearable
                       filterable></el-cascader>
        </div>
      </div>
      <div>
        <div class="product_infro_title">
          <label>
            <span style="color: red">*</span>
            产品概况：
          </label>
        </div>
        <!-- <div>{{content}}</div> -->
        <editor-spu-detial @content_change="content_change"
                           :editor_content="content"
                           ref="editor_cnp"></editor-spu-detial>
      </div>
      <!-- 提交按钮 -->

      <div>
        <el-button @click="submitSpuInfro()">更新基本信息</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import Editor from '../editor/editorV1'
export default {
  name: 'spu-modify',
  components: {
    'editor-spu-detial': Editor,
  },
  data() {
    return {
      // 产品信息
      spu_name: '',
      spu_id: '',
      out_spu_id: '',
      image_url: '', // 返回的图片链接
      imageUrl: '', // 上传图片框 处 的 图片链接， 通过v-if判断，如果有则显示图片，如果没有则不显示图片
      selectDests: [], // 多级请添加 id的列表[[2,3,4],[4,3,2],6]
      file_name: 'image', // 提交给后端事 使用的 字段名 上传的文件字段名
      defaultProp: {
        // element联级选择的 的props 属性，用于配置选择器的属性
        multiple: true,
        checkStrictly: true,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      option: [],
      content: '',
    }
  },
  props: { visable_spu_modify: false },
  // 组件有一个属性，就是是否显示 title
  // 方法
  methods: {
    // 生成编号
    creatOutSpuId() {
      let post_info = {
        dest: this.selectDests,
        sku_name: this.spu_name,
      }
      this.$http.post('/creat_spu_out_id', post_info).then((res) => {
        const { out_spu_id, errno, errmsg } = res.data
        if (errno == '4002') {
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        } else if (errno == '0') {
          this.out_spu_id = out_spu_id
        }
      })
    },
    //提交产品更新
    submitSpuInfro() {
      let new_spu_info = {}
      new_spu_info.spu_name = this.spu_name
      new_spu_info.out_spu_id = this.out_spu_id
      new_spu_info.spu_id = this.spu_id
      new_spu_info.spu_avatar = this.image_url
      new_spu_info.spu_dest = this.selectDests
      new_spu_info.spu_detail = this.content

      this.$http.post('/product/renew_spu_info', new_spu_info).then((res) => {
        const { data, errmsg, errno } = res.data
        if (errno == '0') {
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
        } else if (errno == '4001') {
          this.$notify.error({
            title: '错误',
            message: errmsg,
          })
        }
      })
    },
    content_change(editor_introduce) {
      this.content = editor_introduce
      //   console.log(this.content);
    },
    getSpuInfo() {
      this.loadDest()
      this.spu_id = this.$parent.$parent.$parent.$parent.spu_id
      this.spu_name = this.$parent.$parent.$parent.$parent.spu_name
      this.out_spu_id = this.$parent.$parent.$parent.$parent.out_spu_id
      this.imageUrl = this.$parent.$parent.$parent.$parent.spu_image
      this.image_url = this.$parent.$parent.$parent.$parent.spu_image
      // console.log(this.$parent.$parent.$parent.$parent.spu_id);
      //console.log(this.$parent.$parent.spu_dest_id); // 获得目的的id
      // 获取pid
      //   .push(parseInt(this.$parent.$parent.spu_dest_id));
      //   console.log(this.$parent.$parent);
      this.selectDests = this.$parent.$parent.$parent.$parent.spu_dest_pid
      //   console.log(this.$parent.$parent.spu_detail);
      this.content = this.$parent.$parent.$parent.$parent.spu_detail
      //   console.log(this.defaultProp.value);
    },

    //   自组件的返回按钮
    close_spu_modify() {
      //   this.$emit("goback");
      location.reload()
      this.$router.push({ path: `/product-intro/spu_id=${this.spu_id}` })
      // this.$parent.$parent.spu_modify = false;
      // this.$parent.$parent.title_pro_info = true;
      //   console.log(this.$parent);
      //   console.log((this.$parent.$parent.title_pro_info = true));
    },

    // 获取目的地信息
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
        // console.log(this.option);
      })
    },

    // 【上传文件前】 的 钩子 函数 用来检查图片是和否符合要求
    beforeAvatarUpload(file) {
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isFORMAT) {
        this.$message.error('上传头像图片只能是 JPG/png/gif 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      //   console.log(file);
      return isFORMAT && isLt2M
    },
    // 目的地变动
    handleChoice() {},

    // 【上传成功】时的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      if (res.errno == '4101') {
        this.$notify({
          title: '警告',
          message: res.errmsg,
          type: 'warning',
        })
        return
      } else if (res.errno == '0') {
        this.image_url = res.data.image_url
        this.imageUrl = URL.createObjectURL(file.raw) // 让图片可以展示在前端
        console.log(this.imageUrl)
        console.log(this.image_url)
      }
    },
    // method 结束
  },
}
</script>

<style>
.modify-contain {
  display: block;
  width: 100%;
  flex: initial;
}
.spu_modify_header {
  padding: 5px;
}
.content-title {
  text-align: center;
  padding: 5px 0;
  margin-right: 10px;
  margin-bottom: 10px;
}
.content-input {
  width: 300px;
}
.content-line-dest {
  margin-top: 20px;
  margin-bottom: 20px;
}

.content-dest {
  padding: 10px 0;
}
/* 主图 */
.avatar-uploader .el-upload {
  margin-top: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.modify_spu_header_title {
  font-size: 13px;
}
.product_infro_title {
  margin-bottom: 10px;
}
.addition_input {
  width: 200px;
}
.addition_input_textara {
  width: 500px;
}
img {
  max-width: 100%;
  max-height: 100%;
}

/*  编辑器样式 */
.ql-editor {
  /* 输入框真实高度 */
  /* background-color: blue; */
  border: 10px solid rgb(255, 255, 255);
  min-height: 500px;
  padding: 20px 35px 20px;
  /* height: 200px; */
}
.quill-editor .ql-toolbar {
  background-color: white;
  border: 1px solid rgb(247, 245, 245);
  box-shadow: 2px 2px 5px 0.05px #cecccc;
}
.ql-container.ql-snow {
  /* 输入框样式 */
  /* width: 80%;
  margin: auto; */
  border: 1px solid rgb(247, 245, 245);
  box-shadow: 2px 2px 5px 0.05px #cecccc;
  margin-bottom: 20px;
}
</style>